const React = require('react');
const PropTypes = require('prop-types');
const { createFragmentContainer, graphql } = require('react-relay/compat');
import get from 'lodash.get';
const ContextComponent = require('../../../global/components/ContextComponent');
import SanitizeHtml from '../../../global/components/SanitizeHtml';

const chatUtils = require('dibs-buyer-layout/src/utils/chat').default;

class ContactDealerSidebarOutsideSales extends ContextComponent {
    render() {
        const { wrapperClass, copyText, viewer } = this.props;

        const { displayName, email, phoneNumber } =
            get(viewer, 'userRelationships[0].userDataB[0]') || {};

        return (
            <div className={wrapperClass} data-tn="pdp-dealer-info">
                <div className="pdp-contact-dealer-title header-primary-large pdp-secondary-header">
                    {copyText.get('questionsAboutItem')}
                </div>
                <div className="pdp-dealer-trade-test-info">
                    <SanitizeHtml
                        className="pdp-dealer-trade-test-title"
                        content={displayName || copyText.get('tradeConcierge')}
                    />
                    <br />
                    <SanitizeHtml content={phoneNumber} />
                    <br />
                    <SanitizeHtml content={email || copyText.get('tradeEmail')} />
                </div>
                <a
                    href="#"
                    className="pdp-dealer-live-chat"
                    onClick={() => {
                        chatUtils.show();
                    }}
                >
                    {copyText.get('liveChat')}
                </a>
            </div>
        );
    }
}

ContactDealerSidebarOutsideSales.propTypes = {
    wrapperClass: PropTypes.string,
    copyText: PropTypes.object,
    viewer: PropTypes.object,
};

module.exports = createFragmentContainer(ContactDealerSidebarOutsideSales, {
    viewer: graphql`
        fragment ContactDealerSidebarOutsideSales_viewer on Viewer {
            userRelationships(userIds: $userIds, relationshipType: TRADE) @include(if: $hasUserId) {
                userDataB {
                    ... on TradeRepData {
                        displayName
                        email
                        phoneNumber
                    }
                }
            }
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/ContactDealerSidebarOutsideSales.jsx